<p-button
  styleClass="bg-white -ml-2 back-button"
  icon="pi pi-angle-left"
  severity="primary"
  size="large"
  [dt]="dt"
  [rounded]="true"
  [outlined]="false"
  (onClick)="onBackClick()"
/>
